import React from 'react';
import styles from './styles/title.module.scss';

function Title({ title }) {
    return <p className={styles.title}>{title}</p>;
}

export default Title;
